import React, { useState } from 'react'
import PdfRenderer from '../../components/PdfRenderer'
import { PRIVACY_POLICY_PDF_URL, TERMS_AND_CONDITIONS_PDF_URL } from '../../constants'
import './TncAndPrivacyPolicy.scss'

const TABS = [
    { id: 'privacy-policy', label: 'Privacy Policy', file: PRIVACY_POLICY_PDF_URL },
    { id: 'terms-and-conditions', label: 'Terms & Conditions', file: TERMS_AND_CONDITIONS_PDF_URL },
]

const TncAndPrivacyPolicy = () => {
    const [activeTab, setActiveTab] = useState(TABS[0].id)
    const activeFile = TABS.find(tab => tab.id === activeTab)?.file

    return (
        <div className="tnc-privacy-page">
            <div className="tab-bar">
                {TABS.map(tab => (
                    <button
                        key={tab.id}
                        className={`tab-item${activeTab === tab.id ? ' active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div className="tab-content">
                <PdfRenderer file={activeFile} />
            </div>
        </div>
    )
}

export default TncAndPrivacyPolicy
